<template><div><head>
  <meta http-equiv="refresh" content="0; url=/foundations/size-and-space/" />
</head>
<p class="d-docsite--paragraph">This page has moved to <a href="/foundations/size-and-space/" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Size and Space</a>.</p>
</div></template>


<script setup>
if (typeof window !== 'undefined') {
  window.location.href = '/foundations/size-and-space/';
}
</script>